module.exports = __webpack_public_path__ + "static/img/31展保云联.7600e2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/31展保云联.jpg
// module id = Wx3l
// module chunks = 1